import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static classes = ['active']

  connect() {
    this.active_link = null;
  }

  disconnect() {
    this.active_link = null;
  }

  handleTurboClick(event) {
    const target = event.currentTarget;

    const { type } = event.params;

    this.close(type);

    if (target.classList.contains("plus")) {
      const item = target.closest(".kanban-item");
      if (item) item.classList.add("bg-orange-100");
    }

    const prev = target.previousElementSibling;
    const next = target.nextElementSibling;
    const className = `open-${type}`;

    if (prev) {
      prev.classList.remove("hidden");
      prev.classList.add(className);
    }
    if (next) {
      next.classList.remove("hidden");
      next.classList.add(className);
    }

    target.classList.add("hidden");
  }


  close(type) {
    Array.from(document.getElementsByClassName("open-" + type)).forEach((element) => {
      if (element.previousElementSibling) {
        element.previousElementSibling.classList.remove("hidden");
      }
      if (element.nextElementSibling) {
        element.nextElementSibling.classList.remove("hidden");
      }
      element.classList.add("hidden");
      element.closest(".kanban-item").classList.remove("bg-orange-100");
    })
  }
}